import { render, staticRenderFns } from "./NewFormulaModal.vue?vue&type=template&id=10942e00&scoped=true"
import script from "./NewFormulaModal.vue?vue&type=script&lang=js"
export * from "./NewFormulaModal.vue?vue&type=script&lang=js"
import style0 from "./NewFormulaModal.vue?vue&type=style&index=0&id=10942e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10942e00",
  null
  
)

export default component.exports